import React, { useState } from "react";
import { Modal, Button, Divider } from "@mantine/core";
import { useForm } from "react-hook-form";
import { TextInput } from "react-hook-form-mantine";
import PDFUpload from "../PDFUpload";
import { useCreateUserDocument } from "../../api/user";
import { web_uploadUserDocumentSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";

const UploadUserDocument = ({ userId, eventId }) => {
  const [opened, setOpened] = useState(false);
  const { control, handleSubmit, reset } = useForm({
    defaultValues: {
      fileName: "",
      fileKey: "",
      fileType: "application/pdf",
      userId,
      eventId,
    },
    resolver: resolver(web_uploadUserDocumentSchema),
  });

  const { mutate, isPending } = useCreateUserDocument();

  const onSubmit = (data) => {
    mutate(data, {
      onSuccess: () => {
        setOpened(false);
        reset();
      },
    });
  };

  return (
    <>
      <Button onClick={() => setOpened(true)}>Upload Document</Button>

      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        title="Upload User Document"
      >
        <form
          onSubmit={(e) => {
            e.preventDefault(); // Prevent default form submission
            handleSubmit(onSubmit)(); // Explicitly call the form's submit handler
          }}
        >
          <TextInput
            label="Document Name"
            placeholder="Enter document name"
            name="fileName"
            withAsterisk
            control={control}
            disabled={isPending}
          />

          <PDFUpload
            control={control}
            name="fileKey"
            label="Upload PDF"
            description="Only PDF files are accepted"
            mt="md"
          />
          <Divider my="md" />
          <Button mt="md" fullWidth size="sm" loading={isPending} type="submit">
            Submit
          </Button>
        </form>
      </Modal>
    </>
  );
};

export default UploadUserDocument;
